// extracted by mini-css-extract-plugin
export default {"linearwipe":"style_linearwipe__k5WMb","animated_text":"style_animated_text__bseLT","line":"style_line__z1GsX","loader":"style_loader__2HIf0","spin":"style_spin__0Ye4-"};